import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Action } from '@ngrx/store'
import { Observable, of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  commentaryActivityLoadFailed,
  commentaryActivityLoaded,
  loadCommentaryActivity,
} from './commentary-activity.reducer'

interface ActivityResponseDto {
  count: number
  openAssigned: number
  tagged: number
}

@Injectable()
export class CommentaryActivityEffects {
  loadActivity$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCommentaryActivity),
      switchMap(({ payload }: { payload: { accountId: string } }) =>
        this.http
          .get<ActivityResponseDto>(
            '/plugin/commentary-ws/external/threads/activity',
            { params: { accountId: payload.accountId } },
          )
          .pipe(
            map(response =>
              commentaryActivityLoaded({
                accountId: payload.accountId,
                count: response?.count ?? 0,
                openAssigned: response?.openAssigned ?? 0,
                tagged: response?.tagged ?? 0,
              }),
            ),
            catchError((err: HttpErrorResponse) =>
              of(
                commentaryActivityLoadFailed({
                  accountId: payload.accountId,
                  error:
                    err?.message ?? `HTTP ${err?.status ?? 'unknown'} error`,
                }),
              ),
            ),
          ),
      ),
    ),
  )

  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
  ) {}
}
